function bundleFormatMoney(cents, format) {
  const placeholder = /\{\{\s*(\w+)\s*\}\}/;

  function withDelimiters(number, precision, thousands, decimal) {
    number = (number / 100).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    return parts[1] ? `${dollars}${decimal}${parts[1]}` : dollars;
  }

  const match = format.match(placeholder);
  const key = match ? match[1] : 'amount';
  let value;
  switch (key) {
    case 'amount_no_decimals':
      value = withDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_with_comma_separator':
      value = withDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = withDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = withDelimiters(cents, 2, ',', '.');
  }
  return format.replace(placeholder, value);
}

document.querySelectorAll('[data-bundle-picker]').forEach((root) => {
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  const money = (cents) => bundleFormatMoney(Math.round(cents), moneyFormat);

  const totalPriceEl = root.querySelector('[data-bundle-total-price]');
  const totalCompareEl = root.querySelector('[data-bundle-compare-price]');
  const addBtn = root.querySelector('[data-bundle-add-to-cart]');
  const addText = root.querySelector('[data-bundle-add-text]');
  const errorEl = root.querySelector('[data-bundle-error]');
  const tierRadios = root.querySelectorAll('[data-bundle-tier-radio]');
  const unitGroups = root.querySelectorAll('[data-bundle-tier-units]');
  const addTextDefault = addText ? addText.textContent : '';

  function visibleUnitGroup() {
    return root.querySelector('[data-bundle-tier-units]:not([hidden])');
  }

  function recompute() {
    const group = visibleUnitGroup();
    const checked = root.querySelector('[data-bundle-tier-radio]:checked');
    if (!group || !checked) return;

    const discount = parseFloat(checked.dataset.tierDiscount || '0');
    let saleSum = 0;
    let compareSum = 0;
    group.querySelectorAll('[data-bundle-unit-select]').forEach((select) => {
      const option = select.options[select.selectedIndex];
      saleSum += parseFloat(option?.dataset.price || '0');
      compareSum += parseFloat(option?.dataset.compare || '0');
    });
    const saleTotal = saleSum * ((100 - discount) / 100);

    if (totalPriceEl) totalPriceEl.textContent = money(saleTotal);
    if (totalCompareEl) {
      totalCompareEl.textContent = money(compareSum);
      totalCompareEl.hidden = compareSum <= saleTotal;
    }

    const row = checked.closest('[data-bundle-tier-row]');
    const rowSale = row?.querySelector('[data-tier-sale-cents]');
    const rowCompare = row?.querySelector('[data-tier-compare-cents]');
    if (rowSale) rowSale.textContent = money(saleTotal);
    if (rowCompare) {
      rowCompare.textContent = money(compareSum);
      rowCompare.hidden = compareSum <= saleTotal;
    }
  }

  tierRadios.forEach((radio) => {
    radio.addEventListener('change', () => {
      if (!radio.checked) return;
      unitGroups.forEach((group) => {
        group.hidden = group.dataset.bundleTierUnits !== radio.value;
      });
      recompute();
    });
  });

  root.querySelectorAll('[data-bundle-unit-select]').forEach((select) => {
    select.addEventListener('change', recompute);
  });

  addBtn?.addEventListener('click', async () => {
    const group = visibleUnitGroup();
    if (!group || addBtn.disabled) return;

    const items = Array.from(group.querySelectorAll('[data-bundle-unit-select]')).map((select) => ({
      id: select.value,
      quantity: 1,
    }));
    if (items.length === 0) return;

    errorEl.hidden = true;
    addBtn.disabled = true;
    if (addText) addText.textContent = addText.dataset.loadingText || addTextDefault;

    try {
      const response = await fetch(`${root.dataset.cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'add_failed');
      }
      window.location.href = root.dataset.cartUrl;
    } catch (error) {
      errorEl.textContent = errorEl.dataset.errorText || 'Something went wrong. Please try again.';
      errorEl.hidden = false;
      addBtn.disabled = false;
      if (addText) addText.textContent = addTextDefault;
    }
  });

  recompute();
});
